module.exports = __webpack_public_path__ + "static/media/be.258dcd7a.jpg";